import { render } from "./deals-dashboard.vue?vue&type=template&id=e6603708&scoped=true"
import script from "./deals-dashboard.vue?vue&type=script&lang=js"
export * from "./deals-dashboard.vue?vue&type=script&lang=js"

import "./deals-dashboard.vue?vue&type=style&index=0&id=e6603708&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6603708"]])

export default __exports__